module.exports = __webpack_public_path__ + "static/darkling-095cd5e5339a8fa34a24c401d189d88e.jpeg";